export default __webpack_public_path__ + "static/media/mobileslider01.02dc6394.png";